import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { roundToThreeDecimals } from '@app/v2/shared/utils';
import { EntitylementTypes } from '@ra-state';
import {
  InputComponent,
  INumericDisplayOpts,
  NumericDisplayOpts,
  NumericInputType,
  UnsignedIntegerDisplayType,
} from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-allocate-quantity',
  templateUrl: './allocate-quantity.component.html',
  styleUrl: './allocate-quantity.component.scss',
  imports: [NgClass, InputComponent],
})
export class AllocateQuantityComponent implements ICellRendererAngularComp {
  params: any;
  isInvalidUserInput: boolean = false;
  availableQuantity: number = 0;
  availableEntitlement: number = 0;
  showInputBox: boolean = false;
  public numericInputType = new NumericInputType();
  public numericParams: INumericDisplayOpts = new NumericDisplayOpts();
  public unsignedIntegerDisplayType = new UnsignedIntegerDisplayType(this.numericParams);
  constructor() {}

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
  agInit(params: any): void {
    this.params = params;
    this.availableQuantity = this.params?.data.available;
    if (this.params.isDeallocateEntitlement) {
      const {
        allocated,
        consumed,
        attributes: { combineType },
        availableQuantity,
      } = this.params.data;
      const isUniversalCredits = combineType === EntitylementTypes.utilityToken;
      this.availableEntitlement = allocated;
      this.availableQuantity = isUniversalCredits
        ? roundToThreeDecimals(allocated - consumed)
        : Number(availableQuantity);
    } else {
      this.availableQuantity = this.params?.data.available;
      this.availableEntitlement = this.params?.data.available;
    }

    if (
      this.params?.data.entitlementType?.toLowerCase() !== EntitylementTypes.platform &&
      this.availableEntitlement > 1
    ) {
      this.showInputBox = true;
    }
  }

  onInputChange(value: any): void {
    const quantity = value;
    if (this.params?.data.entitlementType?.toLowerCase() !== EntitylementTypes.platform) {
      this.isInvalidUserInput = !quantity || quantity > Number(this.availableEntitlement);
      this.params.onAllocationQuantityChanged(this.isInvalidUserInput, quantity);
    }
  }
}
